import { render, staticRenderFns } from "./commentBlock.vue?vue&type=template&id=2e72f700&"
import script from "./commentBlock.vue?vue&type=script&lang=js&"
export * from "./commentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports